/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { Room, RoomEvent } from "livekit-client";
import { ActionAccessControll } from "@/types/public";

export function useReceiveActionAccess(
  target: "mic" | "cam" | "screen",
  room: Room | null | undefined,
  toggleHandler: (data: ActionAccessControll) => void
) {
  useEffect(() => {
    if (!room) return;

    const handler = (
      data: Uint8Array,
      _p?: any,
      _kind?: any,
      topic?: string
    ) => {
      if (topic !== target) return;
      try {
        const parsed = JSON.parse(
          new TextDecoder().decode(data)
        ) as ActionAccessControll;
        toggleHandler(parsed);
      } catch {
        /* ignore invalid payloads */
      }
    };

    room.on(RoomEvent.DataReceived, handler);
    return () => {
      room.off(RoomEvent.DataReceived, handler);
    };
  }, [room, toggleHandler, target]);
}
